angular.module(NgAppName).component('crAgentsSpecialists', {
	templateUrl: 'crAgentsSpecialists.html',
	bindings: {
		rpc: '@',
		buildingType: '@',
		isNewDev: '<',
		graphId: '@',
		pageId: '@',
		isMobile: '<',
		onNoResults: '&'
	},
	controller: ['$element', '$window', '$timeout', '$scope', '$location', '$filter' , '$q', 'gVariables', 'PubSub', 'crResourcesService', 'StateService', function($element, $window, $timeout, $scope, $location, $filter, $q, gVariables, PubSub, crResourcesService, StateService) {
		var self = this;

		this.minSalePrice = 1; // if set to 0, the xAvis shows negative values
		this.maxSalePrice = 100000000;
		this.loaded = false;
		this.firstLoad = true;
		this.hasData = false;
		this.recentSales = {};
		this.valuesToKey = {};
		this.valuesToKeyTop = {};
		this.averageSales = {};

		this.$onInit = () => {
			this.period = '';

			this.categoriesLabel = {
				2: 'Upper West Side',
				1: 'Upper East Side',
				11: 'Midtown',
				3: 'Downtown',
				12: 'Upper Manhattan',
				4: 'Brooklyn',
				5: 'LIC / Queens',
				18: 'The Bronx'
			};
			this.categoriesLabelMobile = {
				2: 'UWS',
				1: 'UES',
				11: 'MWN',
				3: 'DWN',
				12: 'UPM',
				4: 'BKLYN',
				5: 'QNS',
				18: 'BNX'
			};

			this.categoriesLabelTop = { 
				activeListings: 'Total active listings in building & neighborhood:',
				closedSalesBuilding: 'Total closed sales in building: ',
				closedSalesHoods: 'Total closed sales in neighborhood: ',
			};

			this.loadAllData();

		};

		this.loadAllData = (period) => {
			let url = this.rpc + '&yearsBack=3';	
			let promise1 = crResourcesService.get(url).$promise;
			

			url = this.rpc + '&yearsBack=5';
			let promise2 = crResourcesService.get(url).$promise; 

				
			$q.all([promise1, promise2])
			.then((values) => {
				// $timeout(() => {


					this.recentSales['3'] = values[0];
					this.recentSales['5'] = values[1];
					let hasSales3Years = false;
					let hasSales5Years = false;
					
					if (this.recentSales['3'].data.length > 0) {
						this.hasSales3Years = true;
					}
					if (this.recentSales['5'].data.length > 0) {
						this.hasSales5Years = true;
					}

					this.hasData = this.hasSales3Years || this.hasSales5Years;

					this.period = '5';
					if (this.hasSales3Years) {
						this.period = '3';
					}

					if (this.hasData) { 
						$timeout(() => {
							for (let i = 0 ; i < this.recentSales[this.period].data.length ; i++) {
								// for (let i = 0 ; i < 1 ; i++) { 
								this.loadGraphs(this.period, i);
							}
						});
					} else {
						this.onNoResults();
					}

					this.loaded = true; 
					if (this.firstLoad) {
						this.firstLoad = false;
					}
				// });
			})
			.catch((err) => {
				console.log(err);
			});
	
		};

		this.loadGraphs = (period, idx) => {
			// load first graph
			this.loadTopGraph(period, idx);

			// load region graph
			this.loadRegionGraph(period, idx);
		};

		this.loadTopGraph = (period, idx) => {
			const activeListings = this.recentSales[period].data[idx].activeListings;
			const closedSalesBuilding = this.recentSales[period].data[idx].closedSalesBuilding;
			const closedSalesHoods = this.recentSales[period].data[idx].closedSalesHoods;
			const sales = {
				closedSalesBuilding,
				closedSalesHoods,
				activeListings
			};

			const keys = Object.keys(sales);

			this.averageSales[idx] = [];
			for (let i = 0 ; i < keys.length; i++) {
				if (typeof this.valuesToKeyTop[idx] === 'undefined') {
					this.valuesToKeyTop[idx] = {};
				}
				this.valuesToKeyTop[idx][keys.length - i] = keys[i];
			}

			let index = 0;
			let seriesLine = [];
			let seriesDots = [];
			let seriesEmpty = [];

			let minSale = 0;
			let maxSale = 0;

			// Calc min / max sale
			angular.forEach(sales, (value, key) => {
				if (value.data && value.data.length > 0) {
					angular.forEach(value.data, s => {
						let salePrice = parseInt(s.sale_price, 10);
						if (!minSale || salePrice < minSale ) {
							minSale = salePrice;
						}
						if (!maxSale || salePrice > maxSale ) {
							maxSale = salePrice;
						}
					});
				}
			});

			if (minSale === 0) {
				minSale = this.minSalePrice;
			}

			if (maxSale === 0) {
				maxSale = this.maxSalePrice;
			}

			angular.forEach(sales, (value, key) => {
				let serieLine = [];
				let serieDots = [];
				let serieEmptyLine = [];
				// let minSale = 0;
				// let maxSale = this.maxSalePrice;
				if (value.data && value.data.length > 0) {  
					// let minSale = 0;
					// let maxSale = 0;
					// maxSale = 0;
			
					let labelAvg = 'Avg price of ';
					if (value.data.length === 1) {
						labelAvg = 'Price of ';
					}
					this.averageSales[idx].push({ 
						key,
						labelAvg,
						avgPrice: value.avg_format
					});
					let valuesSales = [];
					angular.forEach(value.data, s => {
						valuesSales.push(parseInt(s.sale_price, 10));

						serieDots.push([parseInt(s.sale_price, 10) , keys.length - index]);
					});
					seriesDots.push(serieDots);

					if (valuesSales.length > 1) {
						serieLine = [
							[Math.min(...valuesSales), keys.length - index],
							[Math.max(...valuesSales), keys.length - index]
						];
						seriesLine.push(serieLine);
					}
					
				} else {
					// todo : show region without sales
					this.averageSales[idx].push({ 
						key,
						labelAvg: '',
						avgPrice: null
					});

					serieEmptyLine = [
						[this.minSalePrice, keys.length - index],
						[(minSale + maxSale) / 2, keys.length - index],
						[this.maxSalePrice, keys.length - index] // set a very high value on purpose
					];
					seriesEmpty.push(serieEmptyLine);
				}
				index++;
			});

			this.generateGraph(seriesLine, seriesDots, seriesEmpty, keys, this.valuesToKeyTop, this.categoriesLabelTop, idx, 'top', minSale, maxSale);
		};

		this.loadRegionGraph = (period, idx) => {
			const regionSales = this.recentSales[period].data[idx].regions;
			const keys = regionSales.map(x => x.id);

			for (let i = 0 ; i < keys.length; i++) {
				if (typeof this.valuesToKey[idx] === 'undefined') {
					this.valuesToKey[idx] = {};
				}
				this.valuesToKey[idx][keys.length - i] = keys[i];
			}

			let index = 0;
			let seriesLine = [];
			let seriesDots = [];
			let seriesEmpty = [];

			let minSale = 0;
			let maxSale = 0;
			
			// Calc min / max sale
			angular.forEach(regionSales, (value, key) => {
				if (value.data && value.data.length > 0) {
					angular.forEach(value.data, s => {
						let salePrice = parseInt(s.sale_price, 10);
						if (!minSale || salePrice < minSale ) { 
							minSale = salePrice;
						}
						if (!maxSale || salePrice > maxSale ) {
							maxSale = salePrice;
						}
					});
				}
			});

			if (minSale === 0) {
				minSale = this.minSalePrice;
			}

			if (maxSale === 0) {
				maxSale = this.maxSalePrice;
			}

			// console.log(minSale, maxSale);

			angular.forEach(regionSales, (value, key) => {
				let serieLine = [];
				let serieDots = [];
				let serieEmptyLine = []; 
				// let minSale = 0;
				// let maxSale = this.maxSalePrice;

				if (value.data && value.data.length > 0) {
					// let minSale = 0;
					// let maxSale = 0;
					// maxSale = 0;

					let labelAvg = 'Avg price of ';
					if (value.data.length === 1) {
						labelAvg = 'Price of ';
					}

					let valuesSales = [];
					angular.forEach(value.data, s => {
						valuesSales.push(parseInt(s.sale_price, 10));

						serieDots.push([parseInt(s.sale_price, 10) , keys.length - index]);
					});
					seriesDots.push(serieDots);

					if (valuesSales.length > 1) {
						serieLine = [
							[Math.min(...valuesSales), keys.length - index],
							[Math.max(...valuesSales), keys.length - index]
						];
						seriesLine.push(serieLine);
					}
					
				} else {
					// todo : show region without sales
					serieEmptyLine = [
						[this.minSalePrice, keys.length - index],
						[(minSale + maxSale) / 2, keys.length - index],
						[this.maxSalePrice, keys.length - index] // set a very high value on purpose
					];
					seriesEmpty.push(serieEmptyLine);
				}
				index++;
			});

			let categoriesLab = this.isMobile ? this.categoriesLabelMobile : this.categoriesLabel;
			this.generateGraph(seriesLine, seriesDots, seriesEmpty, keys, this.valuesToKey, categoriesLab, idx, 'region', minSale, maxSale);
		};

		this.switchPeriod = (period) => {
			if (period !== this.period) {
				this.period = period;
				$timeout(() => {
					for (let i = 0 ; i < this.recentSales[this.period].data.length ; i++) {
						this.loadGraphs(this.period, i);
					}
				});
			
			}
		};

		this.getSalesFromPoint = (type, idx, valuesToKey, point) => {
			let key = valuesToKey[idx][point.y];
			let sales = [];
			if (type === 'region') {
				sales = this.recentSales[this.period].data[idx].regions.filter(x => x.id === key)[0].data.filter(s => parseInt(s.sale_price, 10) === point.x);
			} else if (type === 'top') {
				sales = this.recentSales[this.period].data[idx][key].data.filter(s => parseInt(s.sale_price, 10) === point.x);
			} else {
				sales = this.recentSales[this.period].data[idx].sales.filter(s => parseInt(s.sale_price, 10) === point.x);
			}
			
			return sales; 
		}; 

		this.generateGraph = (lines, dots, empties, keys, valuesToKey, categoriesLabel, idx, type, minX, maxX) => {
			let self = this;
			let linesGraph = [];
			let dotsGraph = [];
			let emptyLinesGraph = []; 
			let xAxisVisible = true;
			
			for (let i = 0 ; i < lines.length; i++) {
				linesGraph.push({
					// pointPlacement: 'on',
					type: 'line',
					name: 'serie-' + i,
					color: '#D8EAFE',
					data: lines[i],
					marker: {
						enabled: false
					},
					lineWidth: 22,
					enableMouseTracking: false
				});
			}

			for (let i = 0 ; i < empties.length; i++) {
				emptyLinesGraph.push({
					// pointPlacement: 'on',
					type: 'line',
					name: 'serie-' + i,
					color: '#f0f0f0',
					data: empties[i],
					marker: {
						enabled: false
					},
					lineWidth: 22,
					enableMouseTracking: false
				});
			}

			for (let i = 0 ; i < dots.length; i++) {
				dotsGraph.push({
					// pointPlacement: 'on',
					name: 'serie-' + i,
					color: '#000',
					data: dots[i],
					marker: {
						symbol: 'square',
						width: 5,
						height: 20,
						radius: 10
					} 
				}); 
			}
			// console.log('container-' + this.graphId + '-' + idx + '-' + type);
			Highcharts.chart('container-' + this.graphId + '-' + idx + '-' + type, {
				chart: {
					type: 'scatter',
					zoomType: 'xy',
					backgroundColor: '#f7f7f7'
				},
				title: {
					useHTML: true,
					text: ''
				},
				subtitle: {
					useHTML: true,
					text: ''
				},
			
				xAxis: {
					min: minX || null,
					max: maxX || null,
					visible: xAxisVisible,
					title: {
						enabled: false,
						text: ''
					},
					tickmarkPlacement: 'on',
					startOnTick: true,
					endOnTick: true,
					labels: {
						useHTML: true,
						formatter: (data) => {
							let html = `$${$filter('shortNumberWithComma')(data.value, 2)}`;
							return html;
						}
					},
					gridLineColor: '#cccccc',
					gridLineWidth: 1
				}, 
				yAxis: {
					title: {
						text: ''
					},
					width: '25%',
					labels: {
						align: "left", 
						reserveSpace: true,
						style: {
							textOverflow: 'none'
						},
						formatter: (data) => {
							let key = valuesToKey[idx][data.value];
							let label = '';
							let count = '';
							if (key) {
								label = categoriesLabel[key]; 
								if (type === 'top') {
									count = self.recentSales[self.period].data[idx][key].count; 
								}
							}
							var html = '';
							html += `<div style="font-size: 13px;">${label ? label : ''} <strong>${count}</strong></div>`;
							return html;
						}
					},
					gridLineWidth: 0		
				},

				// pointPlacement: 'on',

				tooltip: {
					enabled: false
					// useHTML: true
				},
			
				plotOptions: {
					series: {
						dataLabels: {
							enabled: true,
							color: '#000',
							style: {fontStyle: 'italic', fontWeight: 'normal', top: '20px', textOutline: false, backgroundColor: 'green'},
							formatter: function() {
								let foundEmpty = false;
								empties.forEach(empty => {
									empty.find(e => {
										if (this.x > self.minSalePrice && this.x < self.maxSalePrice && e[0] === this.x && e[1] === this.y) {
											foundEmpty = true;
										}
									}) 
								});

								let label = '';
								if (foundEmpty) {
									if (type === 'top' && this.y === 1) {
										label = 'No Active Listings';
									} else {
										label = 'No Sales';
									}
								}
								return (foundEmpty ? label : '');
							},
							inside: true,
							rotation: 0,
							y: 11
						},
						pointPadding: 0.1,
						groupPadding: 0
					},
					scatter: { 
						marker: {
							radius: 5,
							states: {
								hover: {
									enabled: true,
									lineColor: 'rgb(100,100,100)'
								}
							}
						},
						states: {
							hover: {
								marker: {
									enabled: false
								}
							}
						}
					}
				},
				legend: {
					enabled: false
				},
				series: [
					...linesGraph, ...dotsGraph, ...emptyLinesGraph
				],
				pointDescriptionFormatter: (data) => {
					let label = categoriesLabel[valuesToKey[idx][data.value]];
					var html = '';
					html += `<div >${label ? label : ''}</div>`;
					return html;
				},

				credits: {
					enabled: false
				}
			});
			
		};



	}]
});
